export const TRUSTPILOT_PROMPT_MILESTONES = [
  "collaboration_report_downloaded",
  "first_meeting_booked",
] as const;

export type TrustpilotPromptMilestone = (typeof TRUSTPILOT_PROMPT_MILESTONES)[number];

export const REVIEW_PLATFORM_SOURCES = ["trustpilot"] as const;

export type ReviewPlatformSource = (typeof REVIEW_PLATFORM_SOURCES)[number];

export function isTrustpilotPromptMilestone(value: unknown): value is TrustpilotPromptMilestone {
  return (
    typeof value === "string" &&
    (TRUSTPILOT_PROMPT_MILESTONES as readonly string[]).includes(value)
  );
}

export function isReviewPlatformSource(value: unknown): value is ReviewPlatformSource {
  return (
    typeof value === "string" &&
    (REVIEW_PLATFORM_SOURCES as readonly string[]).includes(value)
  );
}
